import { Comanda } from '../shared/entity/Comanda';
import { GetManyParams, GetOneParams } from '../shared/types/TypeormTypes';
import { FindManyReq, FindOneReq } from '../shared/types/TypeormTypes';
import api from './api';

const BASE_URL = '/comanda';

class comandaApi {
  async getOne(query: GetOneParams<Comanda>) {
    try {
      let res = await this.getMany({ ...query, take: 1 });
      if (!res.length) {
        throw new Error('Comanda não encontrado.');
      }
      return res[0];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getMany(query: GetManyParams<Comanda>) {
    try {
      let res = await api.post<Comanda[]>(BASE_URL + '/get', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async count(query: GetManyParams<Comanda>) {
    try {
      let res = await api.post<number>(BASE_URL + '/count', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async update(where: Partial<Comanda>, update: Partial<Comanda>) {
    try {
      let res = await api.put(BASE_URL, { update }, { params: where });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async insert(comanda: Partial<Comanda>) {
    try {
      let res = await api.post<Comanda>(BASE_URL, { comanda });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new comandaApi();
